export const AddUsersAndApplications = {
    POST_USERSANDAPPLICATIONS: "POST_USERSANDAPPLICATIONS"
}
